function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.34313 6.84315C6.73366 6.45262 7.36682 6.45262 7.75735 6.84315L12 11.0858L16.2426 6.84315C16.6332 6.45262 17.2663 6.45262 17.6568 6.84315C18.0474 7.23367 18.0474 7.86683 17.6568 8.25736L13.4142 12.5L17.6568 16.7426C18.0474 17.1332 18.0474 17.7663 17.6568 18.1569C17.2663 18.5474 16.6332 18.5474 16.2426 18.1569L12 13.9142L7.75735 18.1569C7.36682 18.5474 6.73366 18.5474 6.34313 18.1569C5.95261 17.7663 5.95261 17.1332 6.34313 16.7426L10.5858 12.5L6.34313 8.25736C5.95261 7.86684 5.95261 7.23367 6.34313 6.84315Z",
  fill: "#666666"
});

var SvgGrayCloseIcon = function SvgGrayCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GrayCloseIcon.4d8bb51c.svg";
export { ForwardRef as ReactComponent };